import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { FolderViewModel } from 'services/documents/domain/model/FolderModel';

import { useKeyPress } from 'presentation/hooks';
import { ModalNotification } from 'presentation/ui/components/modal-notification/ModalNotification';
import { ModalNotificationLevel } from 'presentation/ui/components/modal-notification/ModalNotificationLevel';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';

export interface FolderMoveSuccessNotificationProps {
	sourceFolder: FolderViewModel;
	targetFolder: FolderViewModel;
	onClickConfirm: () => void;
}

export const FolderMoveSuccessNotification = (props: FolderMoveSuccessNotificationProps): JSX.Element => {
	const { sourceFolder, targetFolder, onClickConfirm } = props;

	const l10nContext = useContext(L10nContext);

	useKeyPress('Enter', onClickConfirm);

	const modalMessage = {
		first: l10nContext.translate('view.documents.modal.action.move.successMessage.first', 'Ordner'),
		middle: l10nContext.translate('view.documents.modal.action.move.successMessage.middle', 'wurde in den Ordner'),
		last: l10nContext.translate('view.documents.modal.action.move.successMessage.last', 'verschoben')
	};

	return (
		<>
			<ModalNotification
				caption={l10nContext.translate('common.modal.successCaption', 'Abgeschlossen')}
				level={ModalNotificationLevel.LEVEL_SUCCESS}
			/>

			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<>
						{modalMessage.first} <b>{sourceFolder.Name}</b> {modalMessage.middle} <b>{targetFolder.Name}</b> {modalMessage.last}
					</>
				</ColumnLayoutSection>
			</ColumnLayout>

			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<ButtonPrimary
						buttonText={l10nContext.translate('view.device.modal.action.add.btnSuccess', 'Weiter zur Ordner Detailansicht')}
						onClick={onClickConfirm}
					/>
				</ColumnLayoutSection>
			</ColumnLayout>
		</>
	);
};
